import { Component } from '@angular/core';
import { environment } from '@environment';
import { GeneralInfo } from '@models/general-info';
import { GlobalService } from '@services/global.service';

@Component({
    selector: 'cp-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.less'],
    standalone: false
})
export class BannerComponent {
    info: GeneralInfo = null;

    get system(): string {
        return environment.System;
    }

    constructor(private _globalService: GlobalService) {
        this._globalService.getGeneralInfo().subscribe(
            (response: GeneralInfo) => {
                this.info = response;
            }
        )
    }
}
